import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProjectFolder, BackendQueryProjectFoldersArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_FOLDER } from './schema';

const QUERY = gql`
  query ProjectFolders($workspaceId: ID) {
    projectFolders(workspaceId: $workspaceId) {
      ...ProjectFolder
    }
  }
  ${FRAGMENT_PROJECT_FOLDER}
`;

type Variables = BackendQueryProjectFoldersArgs;
type Result = BackendProjectFolder[];

export const queryProjectFolders = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<Result>(result.data) ?? [];
};
